module.exports = __webpack_public_path__ + "static/media/adv_mindfulness_control-es.07b9e2a1.vtt";